module.exports = {
  "zones": {
    "Asia/Baghdad": ["z", {
      "wallclock": 389059200000,
      "format": "+03/+04",
      "abbrev": "+04",
      "offset": 10800000,
      "posix": 389048400000,
      "save": 3600000,
      "rules": "Iraq"
    }, {
      "wallclock": -1640995200000,
      "format": "+03",
      "abbrev": "+03",
      "offset": 10800000,
      "posix": -1641005856000,
      "save": 0
    }, {
      "wallclock": -2524521600000,
      "format": "BMT",
      "abbrev": "BMT",
      "offset": 10656000,
      "posix": -2524532260000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 10660000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Iraq": [{
      "from": 1991,
      "to": 2007,
      "month": 3,
      "day": [7, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1991,
      "to": 2007,
      "month": 9,
      "day": [7, 1],
      "time": 240,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1985,
      "to": 1990,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1986,
      "to": 1990,
      "month": 2,
      "day": [0, -31],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1984,
      "to": 1985,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1982,
      "to": 1984,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1983,
      "to": 1983,
      "month": 2,
      "day": [7, 31],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1982,
      "to": 1982,
      "month": 4,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }]
  }
};